export enum FormName {
  EXPORTS_FORM = 'scheduledExportsForm',
}

export default FormName;
